// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Credential } from '@daml.js/dtc-credential/lib/Dtc/Credential/V3/Credential';
import TemplateContract from '../../../utils/TemplateContract';

export { groupCredentialsByHolder } from '../allowList/utils';

export const isMemberOfDenyList = (
  credential: TemplateContract<Credential>,
  denyListName: string,
): boolean => {
  return credential.payload.claims.some(
    (claim) => claim.property === 'isMemberOfDenyList' && claim.value === denyListName,
  );
};
